import { render } from "./PlaceCard.vue?vue&type=template&id=39e690fa&scoped=true"
import script from "./PlaceCard.vue?vue&type=script&lang=js"
export * from "./PlaceCard.vue?vue&type=script&lang=js"

import "./PlaceCard.vue?vue&type=style&index=0&id=39e690fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39e690fa"]])

export default __exports__